import { createContext, useContext, useEffect, useState } from "react";
import {
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import axios from "../utils/axios"; 

//the spinner
import { CircularProgress, Box } from "@mui/material";

// const firebaseConfig = {
//   apiKey: "AIzaSyCAIvT2qEfLc7OBX-tCjoQO_ygEndxa7Xs",
//   authDomain: "loungeatlasportal.firebaseapp.com",
//   projectId: "loungeatlasportal",
//   storageBucket: "loungeatlasportal.appspot.com",
//   messagingSenderId: "823127298175",
//   appId: "1:823127298175:web:e88d4d24abb6ab41f72f4a",
//   measurementId: "G-GZ4CJX9YYK"
// };

const firebaseConfig = {
  apiKey: "AIzaSyAnVjogeR_0j75we1i4UKwix6mVzIvU-vQ",
  authDomain: "atlasportal-dc239.firebaseapp.com",
  projectId: "atlasportal-dc239",
  storageBucket: "atlasportal-dc239.firebasestorage.app",
  messagingSenderId: "224065414839",
  appId: "1:224065414839:web:4f43c09716a4f8ea130f32",
  measurementId: "G-WJRRM98E38"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = (email, password) =>
    signInWithEmailAndPassword(auth, email, password);

  const logout = () => signOut(auth);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const token = await user.getIdToken();
          const res = await axios.get("/user-info", {
            headers: { Authorization: `Bearer ${token}` },
          });

          // Merge firebase user and backend user info into a new object
          const backendUser = res.data;
          // Defensive: log backendUser for debugging
          setCurrentUser({
            ...backendUser, // backend fields (id, user_id, created_at, etc.)
            firebaseUser: user, // keep the original firebase user for getIdToken
          });
        } catch (err) {
          console.error("Failed to fetch user role:", err);
          setCurrentUser(user); // fallback without custom claims
        }
      } else {
        setCurrentUser(null);
      }

      setLoading(false);
    });

    return unsubscribe;
  }, []);


  if (loading)

    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
      <CircularProgress
        sx={{
          animationDuration: "850ms" 
        }}
      />      </Box>
    );
  return (
    <AuthContext.Provider value={{ currentUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};



export const useAuth = () => useContext(AuthContext);
